import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import AuthModal from "@/components/AuthModal";
import Landing from "@/pages/Landing";
import Templates from "@/pages/Templates";
import Marketplace from "@/pages/Marketplace";
import Compliance from "@/pages/Compliance";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Dashboard from "@/pages/Dashboard";
import Builder from "@/pages/Builder";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-center text-slate-500">Loading...</div>;
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function Shell() {
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState("login");

  const openAuth = (mode) => { setAuthMode(mode); setAuthOpen(true); };

  return (
    <div className="App min-h-screen">
      <Navbar onOpenAuth={openAuth} />
      <Routes>
        <Route path="/" element={<Landing onOpenAuth={openAuth} />} />
        <Route path="/templates" element={<Templates onOpenAuth={openAuth} />} />
        <Route path="/marketplace" element={<Marketplace />} />
        <Route path="/compliance" element={<Compliance />} />
        <Route path="/pricing" element={<Pricing onOpenAuth={openAuth} />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
        <Route path="/build/:projectId" element={<Protected><Builder /></Protected>} />
      </Routes>
      <AuthModal open={authOpen} mode={authMode} onOpenChange={setAuthOpen} />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </BrowserRouter>
  );
}
